import { type CountryCode, type Language } from 'ecosystem'

export const countryNames: Record<Language, Record<CountryCode, string>> = {
  en: {
    AD: 'Andorra',
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AG: 'Antigua and Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AO: 'Angola',
    AQ: 'Antarctica',
    AR: 'Argentina',
    AS: 'American Samoa',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Åland Islands',
    AZ: 'Azerbaijan',
    BA: 'Bosnia and Herzegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BR: 'Brazil',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Democratic Republic of the Congo',
    CF: 'Central African Republic',
    CG: 'Republic of the Congo',
    CH: 'Switzerland',
    CI: 'Ivory Coast',
    CK: 'Cook Islands',
    CL: 'Chile',
    CM: 'Cameroon',
    CN: 'China',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cabo Verde',
    CW: 'Curaçao',
    CX: 'Christmas Island',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    EH: 'Western Sahara',
    ER: 'Eritrea',
    ES: 'Spain',
    ET: 'Ethiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falkland Islands',
    FM: 'Micronesia',
    FO: 'Faroe Islands',
    FR: 'France',
    GA: 'Gabon',
    GB: 'United Kingdom',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'French Guiana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Equatorial Guinea',
    GR: 'Greece',
    GS: 'South Georgia and the South Sandwich Islands',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hong Kong',
    HN: 'Honduras',
    HR: 'Croatia',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    HU: 'Hungary',
    ID: 'Indonesia',
    IE: 'Ireland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'India',
    IO: 'British Indian Ocean Territory',
    IQ: 'Iraq',
    IR: 'Iran',
    IS: 'Iceland',
    IT: 'Italy',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KI: 'Kiribati',
    KM: 'Comoros',
    KN: 'Saint Kitts and Nevis',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KY: 'Cayman Islands',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Morocco',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Saint Martin',
    MG: 'Madagascar',
    MH: 'Marshall Islands',
    MK: 'North Macedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macau',
    MP: 'Northern Mariana Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'New Caledonia',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Netherlands',
    NO: 'Norway',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Poland',
    PM: 'Saint Pierre and Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palestine',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Russia',
    RW: 'Rwanda',
    SA: 'Saudi Arabia',
    SB: 'Solomon Islands',
    SC: 'Seychelles',
    SD: 'Sudan',
    SE: 'Sweden',
    SG: 'Singapore',
    SH: 'Saint Helena',
    SI: 'Slovenia',
    SJ: 'Svalbard and Jan Mayen',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    SS: 'South Sudan',
    ST: 'Sao Tome and Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syria',
    SZ: 'Eswatini',
    TC: 'Turks and Caicos Islands',
    TD: 'Chad',
    TF: 'French Southern Territories',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkey',
    TT: 'Trinidad and Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'United States Minor Outlying Islands',
    US: 'United States',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VC: 'Saint Vincent and the Grenadines',
    VE: 'Venezuela',
    VG: 'British Virgin Islands',
    VI: 'U.S. Virgin Islands',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis and Futuna',
    WS: 'Samoa',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  sv: {
    AD: 'Andorra',
    AE: 'Förenade Arabemiraten',
    AF: 'Afghanistan',
    AG: 'Antigua och Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AO: 'Angola',
    AQ: 'Antarktis',
    AR: 'Argentina',
    AS: 'Amerikanska Samoa',
    AT: 'Österrike',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Ålandsöarna',
    AZ: 'Azerbajdzjan',
    BA: 'Bosnien och Hercegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius och Saba',
    BR: 'Brasilien',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Vitryssland',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Demokratiska republiken Kongo',
    CF: 'Centralafrikanska republiken',
    CG: 'Republiken Kongo',
    CH: 'Schweiz',
    CI: 'Elfenbenskusten',
    CK: 'Cooköarna',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'Kina',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Kuba',
    CV: 'Kab Verde',
    CW: 'Curaçao',
    CX: 'Julön',
    CY: 'Cypern',
    CZ: 'Tjeckien',
    DE: 'Tyskland',
    DJ: 'Djibouti',
    DK: 'Danmark',
    DM: 'Dominica',
    DO: 'Dominikanska republiken',
    DZ: 'Algeriet',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Egypten',
    EH: 'Västsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Etiopien',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falklandsöarna',
    FM: 'Micronesia',
    FO: 'Färöarna',
    FR: 'Frankrike',
    GA: 'Gabon',
    GB: 'Storbritannien',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'Franska Guyana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grönland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Ekvatorialguinea',
    GR: 'Grekland',
    GS: 'Sydgeorgien och Sydsandwichöarna',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HM: 'Heardön och McDonaldöarna',
    HU: 'Ungern',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Brittiska territoriet i Indiska oceanen',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kirgizistan',
    KH: 'Kambodja',
    KI: 'Kiribati',
    KM: 'Komorerna',
    KN: 'Saint Kitts och Nevis',
    KP: 'Nordkorea',
    KR: 'Sydkorea',
    KW: 'Kuwait',
    KY: 'Caymanöarna',
    KZ: 'Kazakstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxemburg',
    LV: 'Lettland',
    LY: 'Libyen',
    MA: 'Marocko',
    MC: 'Monaco',
    MD: 'Moldavien',
    ME: 'Montenegro',
    MF: 'Saint Martin',
    MG: 'Madagaskar',
    MH: 'Marshallöarna',
    MK: 'Nordmakedonien',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongoliet',
    MO: 'Macau',
    MP: 'Nordmarianerna',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldiverna',
    MW: 'Malawi',
    MX: 'Mexiko',
    MY: 'Malaysia',
    MZ: 'Moçambique',
    NA: 'Namibia',
    NC: 'Nya Kaledonien',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Nederländerna',
    NO: 'Norge',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Nya Zeeland',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Franska Polynesien',
    PG: 'Papua Nya Guinea',
    PH: 'Filippinerna',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint Pierre och Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palestina',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Rumänien',
    RS: 'Serbien',
    RU: 'Ryssland',
    RW: 'Rwanda',
    SA: 'Saudiarabien',
    SB: 'Salomonöarna',
    SC: 'Seychellerna',
    SD: 'Sudan',
    SE: 'Sverige',
    SG: 'Singapore',
    SH: 'Sankt Helena',
    SI: 'Slovenien',
    SJ: 'Svalbard och Jan Mayen',
    SK: 'Slovakien',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Sydsudan',
    ST: 'Sao Tomé och Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrien',
    SZ: 'Eswatini',
    TC: 'Turks- och Caicosöarna',
    TD: 'Tchad',
    TF: 'Franska sydterritorierna',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadzjikistan',
    TK: 'Tokelau',
    TL: 'Östtimor',
    TM: 'Turkmenistan',
    TN: 'Tunisien',
    TO: 'Tonga',
    TR: 'Turkiet',
    TT: 'Trinidad och Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraina',
    UG: 'Uganda',
    UM: 'Förenta staternas mindre utträdeliggande öar',
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatikanstaten',
    VC: 'Saint Vincent och Grenadinerna',
    VE: 'Venezuela',
    VG: 'Brittiska Jungfruöarna',
    VI: 'U.S. Jungfruöarna',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis och Futuna',
    WS: 'Samoa',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'Sydafrika',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  no: {
    AD: 'Andorra',
    AE: 'De forente arabiske emirater',
    AF: 'Afghanistan',
    AG: 'Antigua og Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AO: 'Angola',
    AQ: 'Antarktis',
    AR: 'Argentina',
    AS: 'Amerikansk Samoa',
    AT: 'Østerrike',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Ålandsøyene',
    AZ: 'Aserbajdsjan',
    BA: 'Bosnia-Hercegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgia',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius og Saba',
    BR: 'Brasil',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Hviterussland',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Den demokratiske republikken Kongo',
    CF: 'Sentralafrikanske republikk',
    CG: 'Republikken Kongo',
    CH: 'Sveits',
    CI: 'Elfenbenskysten',
    CK: 'Cookøyene',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'Kina',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Kap Verde',
    CW: 'Curaçao',
    CX: 'Juleøya',
    CY: 'Kypros',
    CZ: 'Tsjekkia',
    DE: 'Tyskland',
    DJ: 'Djibouti',
    DK: 'Danmark',
    DM: 'Dominica',
    DO: 'Den dominikanske republikk',
    DZ: 'Algerie',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Egypt',
    EH: 'Vest-Sahara',
    ER: 'Eritrea',
    ES: 'Spania',
    ET: 'Etiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falklandsøyene',
    FM: 'Micronesia',
    FO: 'Færøyene',
    FR: 'Frankrike',
    GA: 'Gabon',
    GB: 'Storbritannia',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'Fransk Guyana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grønland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Ekvatorial-Guinea',
    GR: 'Hellas',
    GS: 'Sør-Georgia og Sør-Sandwichøyene',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HN: 'Honduras',
    HR: 'Kroatia',
    HT: 'Haiti',
    HM: 'Heard- og McDonaldøyene',
    HU: 'Ungarn',
    ID: 'Indonesia',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Man',
    IN: 'India',
    IO: 'Det britiske territoriet i Indiahavet',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italia',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kirgisistan',
    KH: 'Kambodsja',
    KI: 'Kiribati',
    KM: 'Komorene',
    KN: 'Saint Kitts og Nevis',
    KP: 'Nord-Korea',
    KR: 'Sør-Korea',
    KW: 'Kuwait',
    KY: 'Caymanøyene',
    KZ: 'Kasakhstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxembourg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Saint Martin',
    MG: 'Madagaskar',
    MH: 'Marshalløyene',
    MK: 'Nord-Makedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macau',
    MP: 'Nord-Marianene',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldivene',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'Ny-Caledonia',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Nederland',
    NO: 'Norge',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Fransk Polynesia',
    PG: 'Papua Ny-Guinea',
    PH: 'Filippinene',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint Pierre og Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palestina',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Russland',
    RW: 'Rwanda',
    SA: 'Saudi-Arabia',
    SB: 'Salomonøyene',
    SC: 'Seychellene',
    SD: 'Sudan',
    SE: 'Sverige',
    SG: 'Singapore',
    SH: 'Sankt Helena',
    SI: 'Slovenia',
    SJ: 'Svalbard og Jan Mayen',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Sør-Sudan',
    ST: 'Sao Tome og Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syria',
    SZ: 'Eswatini',
    TC: 'Turks- og Caicosøyene',
    TD: 'Tsjad',
    TF: 'De franske sørlige territoriene',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadsjikistan',
    TK: 'Tokelau',
    TL: 'Øst-Timor',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Tyrkia',
    TT: 'Trinidad og Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraina',
    UG: 'Uganda',
    UM: 'USAs mindre utvisningliggende øyer',
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VA: 'Vatikanstaten',
    VC: 'Saint Vincent og Grenadinene',
    VE: 'Venezuela',
    VG: 'De britiske jomfruøyene',
    VI: 'U.S. Virgin Islands',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis og Futuna',
    WS: 'Samoa',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'Sør-Afrika',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  de: {
    AD: 'Andorra',
    AE: 'Vereinigte Arabische Emirate',
    AF: 'Afghanistan',
    AG: 'Antigua und Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AO: 'Angola',
    AQ: 'Antarktis',
    AR: 'Argentinien',
    AS: 'Amerikanisch-Samoa',
    AT: 'Österreich',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Åland-Inseln',
    AZ: 'Aserbaidschan',
    BA: 'Bosnien und Herzegowina',
    BB: 'Barbados',
    BD: 'Bangladesch',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivien',
    BQ: 'Bonaire, Sint Eustatius und Saba',
    BR: 'Brasilien',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvetinsel',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Kokosinseln (Keelinginseln)',
    CD: 'Demokratische Republik der Kongo',
    CF: 'Zentralafrikanische Republik',
    CG: 'Republik Kongo',
    CH: 'Schweiz',
    CI: 'Elfenbeinküste',
    CK: 'Cookinseln',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'China',
    CO: 'Kolumbien',
    CR: 'Costa Rica',
    CU: 'Kuba',
    CV: 'Kap Verde',
    CW: 'Curaçao',
    CX: 'Weihnachtsinsel',
    CY: 'Zypern',
    CZ: 'Tschechische Republik',
    DE: 'Deutschland',
    DJ: 'Dschibuti',
    DK: 'Dänemark',
    DM: 'Dominica',
    DO: 'Dominikanische Republik',
    DZ: 'Algerien',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Ägypten',
    EH: 'Westsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Äthiopien',
    FI: 'Finnland',
    FJ: 'Fidschi',
    FK: 'Falklandinseln',
    FM: 'Mikronesien',
    FO: 'Färöer-Inseln',
    FR: 'Frankreich',
    GA: 'Gabun',
    GB: 'Vereinigtes Königreich',
    GD: 'Grenada',
    GE: 'Georgien',
    GF: 'Französisch-Guayana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grönland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Äquatorialguinea',
    GR: 'Griechenland',
    GS: 'Südgeorgien und die Südlichen Sandwichinseln',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HM: 'Heard Island und McDonald Islands',
    HU: 'Ungarn',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Britisches Territorium im Indischen Ozean',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaika',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenia',
    KG: 'Kirgisistan',
    KH: 'Kambodscha',
    KI: 'Kiribati',
    KM: 'Komoren',
    KN: 'St. Kitts und Nevis',
    KP: 'Nordkorea',
    KR: 'Südkorea',
    KW: 'Kuwait',
    KY: 'Cayman Islands',
    KZ: 'Kasachstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'St. Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxemburg',
    LV: 'Lettland',
    LY: 'Libyen',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldawien',
    ME: 'Montenegro',
    MF: 'St. Martin',
    MG: 'Madagaskar',
    MH: 'Marshallinseln',
    MK: 'Nordmazedonien',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolei',
    MO: 'Macau',
    MP: 'Nördliche Marianen',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Malediven',
    MW: 'Malawi',
    MX: 'Mexiko',
    MY: 'Malaysia',
    MZ: 'Mosambik',
    NA: 'Namibia',
    NC: 'Neukaledonien',
    NE: 'Niger',
    NF: 'Norfolkinsel',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Niederlande',
    NO: 'Norwegen',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Neuseeland',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Französisch-Polynesien',
    PG: 'Papua-Neuguinea',
    PH: 'Philippinen',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'St. Pierre und Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palästina',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Katar',
    RE: 'Réunion',
    RO: 'Rumänien',
    RS: 'Serbien',
    RU: 'Russland',
    RW: 'Ruanda',
    SA: 'Saudi-Arabien',
    SB: 'Salomonen',
    SC: 'Seychellen',
    SD: 'Sudan',
    SE: 'Schweden',
    SG: 'Singapur',
    SH: 'St. Helena',
    SI: 'Slowenien',
    SJ: 'Spitzbergen und Jan Mayen',
    SK: 'Slowakei',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Südsudan',
    ST: 'São Tomé und Príncipe',
    SV: 'El Salvador Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrien',
    SZ: 'Eswatini',
    TC: 'Turks- und Caicosinseln',
    TD: 'Tschad',
    TF: 'Französische Südterritorien',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadschikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunesien',
    TO: 'Tonga',
    TR: 'Türkei',
    TT: 'Trinidad und Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tansania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'United States Minor Out liegende Inseln',
    US: 'Vereinigte Staaten',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VA: 'Vatikanstadt',
    VC: 'St. Vincent und die Grenadinen',
    VE: 'Venezuela',
    VG: 'Britische Jungferninseln',
    VI: 'U.S. Jungferninseln',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis und Futuna',
    WS: 'Samoa',
    YE: 'Jemen',
    YT: 'Mayotte',
    ZA: 'Südafrika',
    ZM: 'Sambia',
    ZW: 'Simbabwe'
  },
  da: {
    AD: 'Andorra',
    AE: 'Forenede Arabiske Emirater',
    AF: 'Afghanistan',
    AG: 'Antigua og Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AO: 'Angola',
    AQ: 'Antarctica',
    AR: 'Argentina',
    AS: 'Amerikansk Samoa',
    AT: 'Østrig',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Ålandsøerne',
    AZ: 'Aserbajdsjan',
    BA: 'Bosnien-Hercegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius og Saba',
    BR: 'Brasilien',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Hviderusland',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Den Demokratiske Republik Congo',
    CF: 'Den Centralafrikanske Republik',
    CG: 'Republikken Congo',
    CH: 'Schweiz',
    CI: 'Elfenbenskysten',
    CK: 'Cookøerne',
    CL: 'Chile',
    CM: 'Cameroun',
    CN: 'Kina',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Kab Verde',
    CW: 'Curaçao',
    CX: 'Juleøen',
    CY: 'Cypern',
    CZ: 'Tjekkiet',
    DE: 'Tyskland',
    DJ: 'Djibouti',
    DK: 'Danmark',
    DM: 'Dominica',
    DO: 'Den Dominikanske Republik',
    DZ: 'Algeriet',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Egypten',
    EH: 'Vestsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Etiopien',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falklandsøerne',
    FM: 'Mikronesien',
    FO: 'Færøerne',
    FR: 'Frankrig',
    GA: 'Gabon',
    GB: 'Storbritannien',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'Fransk Guyana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grønland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Ækvatorialguinea',
    GR: 'Grækenland',
    GS: 'Sydgeorgien og Sydsandwichøerne',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HM: 'Heard- og McDonaldøerne',
    HU: 'Ungarn',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Det Britiske Territorium i Det Indiske Ocean',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kirgisistan',
    KH: 'Cambodja',
    KI: 'Kiribati',
    KM: 'Comorerne',
    KN: 'Saint Kitts og Nevis',
    KP: 'Nordkorea',
    KR: 'Sydkorea',
    KW: 'Kuwait',
    KY: 'Caymanøerne',
    KZ: 'Kasakhstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxembourg',
    LV: 'Letland',
    LY: 'Libyen',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Sankt Martin',
    MG: 'Madagaskar',
    MH: 'Marshalløerne',
    MK: 'Nordmakedonien',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongoliet',
    MO: 'Macau',
    MP: 'Nordmarianerne',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldiverne',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'Ny Kaledonien',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Holland',
    NO: 'Norge',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Fransk Polynesien',
    PG: 'Papua Ny Guinea',
    PH: 'Filippinerne',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint Pierre og Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palæstina',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Rumænien',
    RS: 'Serbien',
    RU: 'Rusland',
    RW: 'Rwanda',
    SA: 'Saudi-Arabien',
    SB: 'Salomonøerne',
    SC: 'Seychellerne',
    SD: 'Sudan',
    SE: 'Sverige',
    SG: 'Singapore',
    SH: 'Sankt Helena',
    SI: 'Slovenien',
    SJ: 'Svalbard og Jan Mayen',
    SK: 'Slovakiet',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    SS: 'Sydsudan',
    ST: 'Sao Tome og Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrien',
    SZ: 'Eswatini',
    TC: 'Turks- og Caicosøerne',
    TD: 'Tchad',
    TF: 'De franske sydlige territorier',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadsjikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunesien',
    TO: 'Tonga',
    TR: 'Tyrkiet',
    TT: 'Trinidad og Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: "USA's mindre udeladelse liggende øer",
    US: 'USA',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VA: 'Vatikanstaten',
    VC: 'Saint Vincent og Grenadinerne',
    VE: 'Venezuela',
    VG: 'Britiske Jomfruøer',
    VI: 'U.S. Virgin Islands',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis og Futuna',
    WS: 'Samoa',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'Sydafrika',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  fi: {
    AD: 'Andorra',
    AE: 'Yhdistyneet arabiemiirikunnat',
    AF: 'Afghanistan',
    AG: 'Antigua ja Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AO: 'Angola',
    AQ: 'Antarktis',
    AR: 'Argentiina',
    AS: 'American Samoa',
    AT: 'Itävalta',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Ahvenanmaa',
    AZ: 'Azerbaidžan',
    BA: 'Bosnia ja Hertsegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgia',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius ja Saba',
    BR: 'Brasilia',
    BS: 'Bahama',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Valko-Venäjä',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Kookossaaret (Keelingsaaret)',
    CD: 'Kongon demokraattinen tasavalta',
    CF: 'Keski-Afrikan tasavalta',
    CG: 'Kongon tasavalta',
    CH: 'Sveitsi',
    CI: 'Norsunluurannikko',
    CK: 'Cookinsaaret',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'Kiina',
    CO: 'Kolumbia',
    CR: 'Costa Rica',
    CU: 'Kuuba',
    CV: 'Kap Verde',
    CW: 'Curaçao',
    CX: 'Joulusaari',
    CY: 'Kypros',
    CZ: 'Czech Republic',
    DE: 'Saksa',
    DJ: 'Djibouti',
    DK: 'Tanska',
    DM: 'Dominica',
    DO: 'Dominikaaninen tasavalta',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Viro',
    EG: 'Egypti',
    EH: 'Länsi-Sahara',
    ER: 'Eritrea',
    ES: 'Espanja',
    ET: 'Etiopia',
    FI: 'Suomi',
    FJ: 'Fiji',
    FK: 'Falkland Saaret',
    FM: 'Mikronesia',
    FO: 'Färsaaret',
    FR: 'Ranska',
    GA: 'Gabon',
    GB: 'Yhdistynyt kuningaskunta',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'Ranskan Guayana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grönlanti',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Päiväntasaajan Guinea',
    GR: 'Kreikka',
    GS: 'Etelä-Georgia ja Eteläiset Sandwichsaaret',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HN: 'Honduras',
    HR: 'Kroatia',
    HT: 'Haiti',
    HM: 'Heard Island ja McDonaldinsaaret',
    HU: 'Unkari',
    ID: 'Indonesia',
    IE: 'Irlanti',
    IL: 'Israel',
    IM: 'Mansaari',
    IN: 'Intia',
    IO: 'Brittiläinen Intian valtameren alue',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Islanti',
    IT: 'Italia',
    JE: 'jersey',
    JM: 'Jamaika',
    JO: 'Jordan',
    JP: 'Japani',
    KE: 'Kenya',
    KG: 'Kirgyzstan',
    KH: 'Kambodža',
    KI: 'Kiribati',
    KM: 'Komorit',
    KN: 'Saint Kitts ja Nevis',
    KP: 'Pohjois-Korea',
    KR: 'Etelä-Korea',
    KW: 'Kuwait',
    KY: 'Caymansaaret',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Liettua',
    LU: 'Luxemburg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Saint-Martin',
    MG: 'Madagaskar',
    MH: 'Marshallinsaaret',
    MK: 'Pohjois-Makedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macao',
    MP: 'Pohjoiset Mariaanisaaret',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Malediivit',
    MW: 'Malawi',
    MX: 'Meksiko',
    MY: 'Malesia',
    MZ: 'Mosambique',
    NA: 'Namibia',
    NC: 'New Caledonia',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Alankomaat',
    NO: 'Norja',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Uusi-Seelanti',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Ranskan Polynesia',
    PG: 'Papua-Uusi-Guinea',
    PH: 'Filippiinit',
    PK: 'Pakistan',
    PL: 'Puola',
    PM: 'Saint-Pierre ja Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palestiina',
    PT: 'Portugali',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Venäjä',
    RW: 'Rwanda',
    SA: 'Saudi-Arabia',
    SB: 'Salomonsaaret',
    SC: 'Seychellit',
    SD: 'Sudan',
    SE: 'Ruotsi',
    SG: 'Singapore',
    SH: 'Saint Helena',
    SI: 'Slovenia',
    SJ: 'Svalbard ja Jan Mayen',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    SS: 'Etelä-Sudan',
    ST: 'Sao Tome ja Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syyria',
    SZ: 'Eswatini',
    TC: 'Turks- ja Caicossaaret',
    TD: 'Tšad',
    TF: 'Ranskan eteläiset alueet',
    TG: 'Togo',
    TH: 'Thaimaa',
    TJ: 'Tadžikistan',
    TK: 'Tokelau',
    TL: 'Itä-Timor',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkki',
    TT: 'Trinidad ja Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tansania',
    UA: 'Ukraina',
    UG: 'Uganda',
    UM: 'Yhdysvallat Minor Out Maljasaaret',
    US: 'Yhdysvallat',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatikaani',
    VC: 'Saint Vincent ja Grenadiinit',
    VE: 'Venezuela',
    VG: 'Brittiläiset Neitsytsaaret',
    VI: 'Yhdysvaltain Neitsytsaaret',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis ja Futuna',
    WS: 'Samoa',
    YE: 'Jemen',
    YT: 'Mayotte',
    ZA: 'Etelä-Afrikka',
    ZM: 'Sambia',
    ZW: 'Zimbabwe'
  }
}
